import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../../framework/entity/report/report-page/abstract-report-page";
import {EmployeePhonListReportModel} from "./employee-phon-list-report.model";

@Component({
    selector: "wbo-employee-phon-list-report-page",
    templateUrl: "./employee-phon-list-report-page.component.html",
    providers: [provideReportModel(EmployeePhonListReportModel)]
})
export class EmployeePhonListReportPageComponent extends AbstractReportPage {

    constructor(public model: EmployeePhonListReportModel) {
        super();
    }
}
